import type { Recipe } from "@/api/recipes";
import { Card } from "@/components/ui/card";

interface RecipeCardProps {
  recipe: Recipe;
  index: number;
  onClick: () => void;
}

export function RecipeCard({ recipe, index, onClick }: RecipeCardProps) {
  const date = new Date(recipe.createdAt);
  const formattedDate = date.toLocaleDateString("ru-RU", {
    day: "numeric",
    month: "long",
  });

  const staggerClass = index < 6 ? `stagger-${index + 1}` : "stagger-6";

  return (
    <Card
      className={`group cursor-pointer border-border/40 bg-card/80 backdrop-blur-sm hover:bg-card hover:border-primary/20 hover:shadow-lg hover:shadow-primary/5 transition-all duration-300 overflow-hidden animate-fade-in-up ${staggerClass}`}
      onClick={onClick}
    >
      <div className="p-5">
        <div className="flex items-start justify-between gap-3 mb-3">
          <h3
            className="text-lg font-semibold leading-tight group-hover:text-primary transition-colors duration-200"
            style={{ fontFamily: "var(--font-display)", fontWeight: 600 }}
          >
            {recipe.title}
          </h3>
          <span className="text-xs text-muted-foreground/70 whitespace-nowrap mt-1">
            {formattedDate}
          </span>
        </div>

        <div className="flex items-center gap-4 text-xs text-muted-foreground">
          <span className="flex items-center gap-1.5">
            <svg
              className="w-3.5 h-3.5"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M6 13.87A4 4 0 0 1 7.41 6a5.11 5.11 0 0 1 1.05-1.54 5 5 0 0 1 7.08 0A5.11 5.11 0 0 1 16.59 6 4 4 0 0 1 18 13.87V21H6Z" />
              <line x1="6" x2="18" y1="17" y2="17" />
            </svg>
            {recipe.ingredients.length} ингр.
          </span>
          <span className="flex items-center gap-1.5">
            <svg
              className="w-3.5 h-3.5"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12 2v4" />
              <path d="m16.2 7.8 2.9-2.9" />
              <path d="M18 12h4" />
              <path d="m16.2 16.2 2.9 2.9" />
              <path d="M12 18v4" />
              <path d="m4.9 19.1 2.9-2.9" />
              <path d="M2 12h4" />
              <path d="m4.9 4.9 2.9 2.9" />
            </svg>
            {recipe.instructions.length} шагов
          </span>
        </div>

        <p
          className="mt-3 text-sm text-muted-foreground/80 line-clamp-2 leading-relaxed"
          style={{ fontFamily: "var(--font-body)" }}
        >
          {recipe.instructions[0]}
        </p>
      </div>
    </Card>
  );
}
